var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3ExteriorCarport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 55V36h3v-4H42v-3.19L21 14.28 0 29.11V59h76v-4h-5zM42 36h5.74L42 41.86V36zm-4 19H24v-9h-6v9H4V31.22l17-12 17 11.69V55zm29 0H42v-7.82L53.39 36h2.11L67 47.18V55zm0-13.14L61.15 36H67v5.86zM32 40h-6v-6h6v6zm-22-6h6v6h-6v-6z",
    fill: "#040404"
  })));
}
export default __webpack_public_path__ + "static/media/E3_Exterior_carport.009c6f52.svg";
export { SvgE3ExteriorCarport as ReactComponent };